import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MessageActions from '@/store/ducks/message';
import ContactMe from '@/components/ContactMe';

const mapStateToProps = (state) => {
  const { messageSentResponse = {}, messageSentError = {} } = state.messageReducer || {};
  return {
    messageSentResponse,
    messageSentError,
  };
};

const mapDispatchToProps = (dispatch) => {
  const { sendMessageRequest } = MessageActions;
  return bindActionCreators({ sendMessageRequest }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactMe);
